module.exports = __webpack_public_path__ + "img/06.5e17a106.jpg";